<template>
  <div class="solutions-swiper-container">
    <div class="swiper-container container" ref="solutionsSwiper">
      <div class="swiper-wrapper ">
        <div class="swiper-slide" v-for="(item, index) in solutionsList" :key="index" @mouseenter="handleMouseEnter($event, index)" @mouseleave="handleMouseLeave">
          <div class="solution-card" @click="handleProductClick(item)">
            <div class="solution-image">
              <img v-lazy="item.coverImg + '?x-oss-process=image/resize,w_335'" alt="yake">
              <div class="solution-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-navigation">
        <div class="swiper-navigation-btn">
          <div class="swiper-button-prev">
            <img src="../assets/images/left.png" alt="" />
          </div>
          <div class="swiper-button-next">
            <img src="../assets/images/right.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swiper from 'swiper';
import { productList } from '@/mock/products';
import 'swiper/css/swiper.css';
import {pushWithLanguage} from "@/utils/routeUtils";

export default {
  name: 'SolutionsSwiper',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiper: null,
      solutionsList: [],
      activeIndex: 0,
      hoverIndex: null
    }
  },
  created() {
    this.solutionsList = this.items
  },
  mounted() {
    // 不再这里初始化 Swiper
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    //跳转
    handleProductClick(item) {
      // 跳转到产品详情页
      if(item.targetUrl){
        pushWithLanguage('/'+ item.targetUrl, this.currentLanguage).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error( err)
          }
        })
      }

    },
    handleResize() {
      if (this.swiper) {
        this.swiper.destroy();
      }
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
    
    updateActiveSlide() {
      if (!this.swiper) return;
      const realIndex = this.swiper.realIndex;
      if (this.activeIndex !== realIndex) {
        this.activeIndex = realIndex;
      }
    },
    
    handleMouseEnter(event, index) {
      // 清除之前的 active-slide
      const previousActive = document.querySelector('.swiper-slide.active-slide');
      if (previousActive) {
        previousActive.classList.remove('active-slide');
      }
      
      // 当前悬停项放大
      const currentSlide = event.currentTarget;
      currentSlide.classList.add('active-slide');
      this.hoverIndex = index;
      
      // 暂停自动播放
      if (this.swiper && this.swiper.autoplay) {
        this.swiper.autoplay.stop();
      }
    },
    
    handleMouseLeave() {
      // 鼠标离开时，取消放大，仅恢复自动播放
      this.hoverIndex = null;
      if (this.swiper) {
        document.querySelectorAll('.swiper-slide.active-slide').forEach(slide => {
          slide.classList.remove('active-slide');
        });
        if (this.swiper.autoplay) {
          this.swiper.autoplay.start();
        }
      }
    },
    
    initSwiper() {
      const self = this;
      this.swiper = new Swiper(this.$refs.solutionsSwiper, {
        centeredSlides: false,
        slidesPerView:4,
        spaceBetween: 23,
        initialSlide: 0,
        loop: false,
        loopAdditionalSlides: 0,
        slideToClickedSlide: true,
        watchActiveIndex: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: function() {
            self.updateActiveSlide();
            // 初始化不放大任何项
          },
          slideChange: function() {
            self.updateActiveSlide();
            // 自动轮播不放大任何项
          },
          slideChangeTransitionEnd: function() {
            self.updateActiveSlide();
          },
          autoplayStart: function() {
            self.updateActiveSlide();
          },
          click: function() {
            self.updateActiveSlide();
          }
        }
      });
      
      // 初始化后立即更新一次
      this.updateActiveSlide();
    }
  },
  watch: {
    items: {
      handler(newVal) {
        this.solutionsList = newVal;
        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.destroy();
          }
          this.initSwiper();
        });
      },
      immediate: true
    },
    // 监听activeIndex变化，更新高亮状态
    activeIndex(newIndex) {
      this.$nextTick(() => {
        // 更新分页器高亮
        const bullets = document.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach((bullet, index) => {
          if (index === newIndex) {
            bullet.classList.add('swiper-pagination-bullet-active');
          } else {
            bullet.classList.remove('swiper-pagination-bullet-active');
          }
        });
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/styles/variables.less';
@import '../assets/styles/mixins.less';

.solutions-swiper-container {
  position: relative;
  padding: 0 0 100px;
  width: 100%;
  
  .swiper-container {
    overflow: hidden;
    padding-bottom: 50px;
    .swiper-wrapper {
      align-items: flex-start;
      display: flex;
      height: 500px;
    }

    /* 去除默认相邻项放大效果 */
    /* .swiper-slide-active + .swiper-slide { ... } 已移除 */
    
    .swiper-slide {
      width: 335px;
      height: 341px;
      transition: all 0.5s ease;
      opacity: 0.8;
      cursor: pointer;

      /* 仅在交互时（鼠标移入）放大 */
      &.active-slide {
        width: 440px !important;
        height: 490px !important;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        position: relative;
        opacity: 1;
        z-index: 10;
        &::after {
          content: ' ';
          display: block;
          height: 40px;
          border-radius: 10px;
          background: #E26E76;
          position: absolute;
          bottom: -6px;
          left: 0;
          right: 0;
          z-index: -1;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        }
      }
    }

    // 自定义分页器样式
    .swiper-pagination {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      
      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        margin: 0 8px;
        background: #ccc;
        opacity: 0.7;
        transition: all 0.3s ease;
        
        &-active {
          background: #19529F;
          opacity: 1;
          transform: scale(1.2);
        }
      }
    }
  }
  
  .solution-card {
    height: 100%;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    position: relative;
    &:hover {
      box-shadow: 0 10px 30px rgba(25, 82, 159, 0.3);
    }
    
    .solution-image {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      
      .solution-title {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 100px 38px 40px;
        font-size: 32px;
        color: #fff;
        text-align: left;
        background: linear-gradient( 180deg, rgba(10,10,10,0) 0%, rgba(10,10,10,0.9) 100%);

      }
    }
  }
  
  .swiper-navigation {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 68px;
    max-width: 1520px;
    margin: 0 auto;
    
    .swiper-navigation-btn{
      position: absolute;
      bottom: -20px;
      right: 20px;
      display: flex;

      &::before{
        content: '';
        position: absolute;
        width: 1154px;
        height: 0;
        border: 1px solid;
        border-image: linear-gradient(270deg, rgba(25, 82, 159, 1), rgba(226, 110, 118, 0.13)) 1 1;
        left: -1184px;
        top: 50%;
        margin-top: -1px;
      }
      
      .swiper-button-prev,
      .swiper-button-next {
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        margin: 0;
        width: 162px;
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 39px;
        cursor: pointer;
        img{
          width: 38px;
          height: 30px;
        }
        &:after {
          display: none;
        }
        transition: all 0.3s ease;
      }

      .swiper-button-prev {
        background: #FFFFFF;
        box-shadow: 0 2px 17px 0 rgba(50, 85, 117, 0.18);

        &:hover {
          background: #f5f5f5;
        }
      }

      .swiper-button-next {
        margin-left: 15px;
        background: #19529F;
        box-shadow: 0 2px 17px 2px rgba(60, 92, 167, 0.5);

        &:hover {
          background: #1a62c0;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .solutions-swiper-container {
    .swiper-container {
      .swiper-slide {
        width: 280px;
        height: 320px;
        
        &.active-slide {
          width: 380px !important;
          height: 420px !important;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .solutions-swiper-container {
    padding: 0 0 60px;
    
    .swiper-container {
      padding-top: 20px;
      
      .swiper-slide {
        width: 240px;
        height: 280px;
        
        &.active-slide {
          width: 300px !important;
          height: 340px !important;
        }
      }
      
      .swiper-pagination {
        .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          margin: 0 5px;
        }
      }
    }
    
    .solution-card {
      .solution-image {
        .solution-title {
          padding: 50px 20px 20px;
          font-size: 18px;
        }
      }
    }
    
    .swiper-navigation {
      .swiper-navigation-btn {
        bottom: 10px;
        right: 10px;
        
        .swiper-button-prev,
        .swiper-button-next {
          width: 120px;
          height: 50px;
        }
      }
    }
  }
}
</style> 